export const calculateThousand = (value) => {
    //value += 10835;
    if (value > 9999) {
        let result = (value / 1000).toFixed(1) + 'K'
        return result
    }
    return value
}

export const shortenLabel = (e) => {
    if (e.length > 20) {
        return e.substring(0, 20) + '...'
    }
    return e
}

export const monthTotalOption = (data) => {
    const values: any[] = data?.map(function (element) {
        return {
            value: element.value,
            itemStyle: {
                color: '#005EB8'
            },
            label: {
                position: 'top',
                fontSize: 16,
                fontWeight: '900'
            }
        }
    })

    const titles = data?.map((d) => d.field)

    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '15%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: titles,
                axisTick: {
                    alignWithLabel: true
                },
                axisLabel: {
                    interval: 0,
                    fontSize: 12,
                    rotate: 30
                }
            }
        ],
        yAxis: [
            {
                type: 'value'
            }
        ],
        series: [
            {
                name: 'Total de notificações',
                type: 'bar',
                barWidth: '60%',
                label: {
                    show: true,
                    formatter: (d) => calculateThousand(d.value)
                },
                data: values
            }
        ]
    }
}

export const OMSOption = (data) => {
    const values: any[] = data?.map(function (element) {
        return {
            value: element.value,
            itemStyle: {
                color: '#005EB8'
            },
            label: {
                position: 'right',
                fontSize: 16,
                fontWeight: '900'
            }
        }
    })

    const options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        grid: {
            left: '3%',
            right: '10%',
            bottom: '2%',
            top: '5%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'value',
                axisTick: {
                    alignWithLabel: true
                }
            }
        ],
        yAxis: [
            {
                type: 'category',
                data: data?.map((d) => d.field),
                axisLabel: {
                    formatter: shortenLabel
                }
            }
        ],
        series: [
            {
                name: 'Notificações por Classificação da OMS',
                type: 'bar',
                barWidth: '60%',
                label: {
                    show: true,
                    formatter: (d) => calculateThousand(d.value)
                },
                data: values
            }
        ]
    }
    return options
}

export const reclassifiedIncidentTypeOption = (data) => {
    const values: any[] = data?.map(function (element) {
        return {
            value: element.value,
            itemStyle: {
                color: '#005EB8'
            },
            label: {
                position: 'right',
                fontSize: 16,
                fontWeight: '900'
            }
        }
    })

    const options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        grid: {
            left: '3%',
            right: '10%',
            bottom: '2%',
            top: '5%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'value',
                axisTick: {
                    alignWithLabel: true
                }
            }
        ],
        yAxis: [
            {
                type: 'category',
                data: data?.map((d) => d.field),
                axisLabel: {
                    formatter: shortenLabel
                }
            }
        ],
        series: [
            {
                name: 'Total Notificações',
                type: 'bar',
                barWidth: '60%',
                label: {
                    show: true,
                    formatter: (d) => calculateThousand(d.value)
                },
                data: values
            }
        ]
    }

    return options
}

export const getBirdTotal = (data) => {
    const baseValue = 100
    const values = data
        ?.map((d) => {
            return {
                value: d?.countPercentage,
                name: d?.label,
                itemStyle: {
                    color: d?.color
                },
                label: {
                    formatter: `${d?.count}`,
                    show: true,
                    color: '#474747'
                }
            }
        })
        .reverse()
    const balancedValues = data
        ?.map((d) => (baseValue - d?.countPercentage) / 2)
        .reverse()

    return {
        tooltip: {
            show: true,
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: function (params) {
                const param = params[0]
                return `
                     <b>${param.name}</b></br>
                      Quantidade: ${param.data.label.formatter}<br />
                      Taxa: ${param.value}%<br />
                      `
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '2%',
            top: '5%'
        },
        xAxis: {
            show: false,
            type: 'value',
            max: baseValue
        },
        yAxis: {
            show: false,
            data: values?.map((v) => v.name),
            type: 'category'
        },
        series: [
            {
                type: 'bar',
                stack: 'Total',
                itemStyle: {
                    borderColor: 'transparent',
                    color: 'transparent'
                },
                emphasis: {
                    itemStyle: {
                        borderColor: 'transparent',
                        color: 'transparent'
                    }
                },
                tooltip: {
                    show: false
                },
                data: balancedValues
            },
            {
                name: 'Quantidade:',
                type: 'bar',
                barWidth: '100%',
                stack: 'Total',
                label: {
                    show: true,
                    position: 'inside',
                    fontSize: 20,
                    fontWeight: '600'
                },
                data: values
            }
        ]
    }
}

export const getAutoNotification = (data) => {
    return {
        tooltip: {
            trigger: 'item',
            formatter: function (params) {
                return `
                     <b>${params.seriesName}</b></br>
                      ${params.name} : ${params.value}%<br/>
            `
            }
        },
        series: [
            {
                name: 'Taxa de autonotificação',
                type: 'pie',
                radius: ['60%', '130%'],
                center: ['58%', '70%'],
                startAngle: 180,
                label: {
                    show: true,
                    formatter(param) {
                        return param.name + ' (' + param.percent * 2 + '%)'
                    }
                },
                data: [
                    {
                        value: data,
                        name: 'Valor',
                        itemStyle: {
                            color: '#005EB8',
                            decal: {
                                symbol: 'none'
                            }
                        },
                        label: {
                            show: false
                        }
                    },
                    {
                        value: 100 - data,
                        name: 'Direct',
                        itemStyle: {
                            color: '#D9D9D9',
                            decal: {
                                symbol: 'none'
                            }
                        },
                        emphasis: {
                            disabled: true
                        },
                        label: {
                            show: false
                        },
                        tooltip: {
                            show: false
                        }
                    },
                    {
                        value: 100,
                        itemStyle: {
                            color: 'none',
                            decal: {
                                symbol: 'none'
                            }
                        },
                        label: {
                            show: false
                        }
                    }
                ]
            }
        ]
    }
}

export const getTotalPerUnityAndSector = (data: any[]) => {
    const values: any[] = data
        ?.sort((o1, o2) => o2.value - o1.value)
        .map(function (element) {
            return {
                value: element.value,
                itemStyle: {
                    color: '#005EB8'
                },
                label: {
                    position: 'top',
                    fontSize: 16,
                    fontWeight: '900'
                }
            }
        })
    const titles = data?.map((d) => d.field)
    const startValue = 0
    const endValue = values?.length < 10 ? 100 : 20
    return {
        toolbox: {
            show: false,
            feature: {
                dataZoom: {
                    yAxisIndex: false
                }
            }
        },
        dataZoom: [
            {
                type: 'inside',
                xAxisIndex: [0, 1],
                start: startValue,
                end: endValue
            },
            {
                show: true,
                xAxisIndex: [0, 1],
                type: 'slider',
                bottom: 10,
                start: startValue,
                end: endValue
            }
        ],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: 50,
            top: '10%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: titles,
                axisTick: {
                    alignWithLabel: true
                },
                axisLabel: {
                    interval: 0,
                    rotate: 90,
                    formatter: shortenLabel
                },
                silent: false,
                splitLine: {
                    show: false
                },
                splitArea: {
                    show: false
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                splitArea: {
                    show: false
                }
            }
        ],
        series: [
            {
                name: 'Total de notificações',
                type: 'bar',
                barWidth: '60%',
                label: {
                    show: true,
                    formatter: (d) => calculateThousand(d.value)
                },
                data: values
            }
        ]
    }
}

export const getTotalPerIncidentSector = (data: any[]) => {
    data = data
        ?.sort((o1, o2) => o2.value - o1.value)
        .map((d, index) => {
            const sumValue =
                (index === 0
                    ? d.value
                    : data
                        .slice(0, index + 1)
                        .map((d) => d.value)
                        .reduce(
                            (acumulador, elemento) => acumulador + elemento,
                            0
                        )) /
                data
                    .map((d) => d.value)
                    .reduce((acumulador, elemento) => acumulador + elemento, 0)
            return {
                field: d.field,
                value: d.value,
                sumValue,
                sumLabel: (sumValue * 100).toFixed(0) + '%'
            }
        })
    const values: any[] = data?.map(function (element) {
        return {
            value: element.value,
            itemStyle: {
                color: '#005EB8'
            },
            label: {
                position: 'top',
                fontSize: 16,
                fontWeight: '900'
            }
        }
    })
    const lineValues: any[] = data?.map(function (element) {
        return {
            value: element.sumValue,
            itemStyle: { color: '#F0B323' }
        }
    })
    const titles = data?.map((d) => d.field)
    const startValue = 0
    const endValue = values?.length < 10 ? 100 : 20
    return {
        toolbox: {
            show: false,
            feature: {
                dataZoom: {
                    yAxisIndex: false
                }
            }
        },
        dataZoom: [
            {
                type: 'inside',
                xAxisIndex: [0, 1],
                start: startValue,
                end: endValue
            },
            {
                show: true,
                xAxisIndex: [0, 1],
                type: 'slider',
                bottom: 10,
                start: startValue,
                end: endValue
            }
        ],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: 50,
            top: '10%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: titles,
                axisTick: {
                    alignWithLabel: true
                },
                axisLabel: {
                    interval: 0,
                    rotate: 90,
                    formatter: shortenLabel
                },
                silent: false,
                splitLine: {
                    show: false
                },
                splitArea: {
                    show: false
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                splitArea: {
                    show: false
                }
            },
            {
                show: false,
                min: 0,
                max: 1,
                type: 'value',
                splitArea: {
                    show: false
                }
            }
        ],
        series: [
            {
                name: 'Total de notificações',
                type: 'bar',
                barWidth: '60%',
                label: {
                    show: true,
                    formatter: (d) => calculateThousand(d.value)
                },
                data: values
            },
            {
                name: 'Quantidade relativa',
                type: 'line',
                yAxisIndex: 1,
                tooltip: {
                    valueFormatter: function (value) {
                        return (value * 100).toFixed(0) + '%'
                    }
                },
                lineStyle: {
                    normal: {
                        color: '#F0B323',
                        width: 5,
                        type: 'solid'
                    }
                },
                symbolSize: 10,
                data: lineValues
            }
        ]
    }
}
